import {
  Component,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import type { AppSettings } from '../../../../app.config';
import { CoreService } from '../../../../../../../shared/src/lib/services/core.service';
import { BrandingComponent } from '../../vertical/sidebar/branding.component';
import { TablerIconComponent } from 'angular-tabler-icons';
import { MaterialModule } from '../../../../material.module';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';

@Component({
    selector: 'app-customizer',
    imports: [
        BrandingComponent,
        TablerIconComponent,
        MaterialModule,
        FormsModule,
        NgScrollbarModule,
    ],
    templateUrl: './customizer.component.html',
    styleUrls: ['./customizer.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CustomizerComponent {
  @Output() optionsChange = new EventEmitter<AppSettings>();
  constructor(private readonly settings: CoreService) {}
  options = this.settings.getOptions();

  setDark() {
    this.optionsChange.emit(this.options);
  }

  setColor() {
    this.optionsChange.emit(this.options);
  }

  setDir() {
    this.optionsChange.emit(this.options);
  }

  setSidebar() {
    this.optionsChange.emit(this.options);
  }
}
